/**
 * When the home page's QA Talent splash may open. Pure, so the rules are tested
 * without a DOM; the component supplies the facts.
 *
 * Owner's choices (2026-09-30): once per visit, about three seconds in.
 */
export type SplashFacts = {
  /** `location.hash`. A visitor who followed a link to a section came for that section. */
  hash: string;
  /** The cookie banner has been answered, now or on an earlier visit. */
  consentAnswered: boolean;
  seenThisVisit: boolean;
  /** Another site popup (the admin-driven banner) is on screen. */
  otherPopupOpen: boolean;
};

export type SplashBlock = 'deep-link' | 'seen' | 'consent-pending' | 'other-popup';

export function splashBlockedBy(facts: SplashFacts): SplashBlock | null {
  if (facts.hash) return 'deep-link';
  if (facts.seenThisVisit) return 'seen';
  if (!facts.consentAnswered) return 'consent-pending';
  if (facts.otherPopupOpen) return 'other-popup';
  return null;
}

/** sessionStorage: "once per visit" is once per tab session. */
const SEEN_KEY = 'waq-talent-splash-seen';

export function hasSeenSplash(storage: Storage = sessionStorage): boolean {
  try {
    return storage.getItem(SEEN_KEY) === '1';
  } catch {
    // Storage we cannot read cannot remember a dismissal either; not showing
    // it is kinder than showing it on every page load.
    return true;
  }
}

export function markSplashSeen(storage: Storage = sessionStorage): void {
  try {
    storage.setItem(SEEN_KEY, '1');
  } catch {
    // Nothing to remember it in.
  }
}

/** Fired by the cookie banner once it has an answer, whatever the answer. */
export const CONSENT_SAVED_EVENT = 'weareqa:consent-saved';

/** Marks the admin-driven banner so the splash can see it and stay closed. */
export const SITE_POPUP_ATTRIBUTE = 'data-site-popup';
